module.exports = __webpack_public_path__ + "img/nft-stars.c509dda2.png";